
<div  class="page_activityapply" style="float:left; padding:20px 40px">
    <a class="btn  on_js"  v-if="isClick" @click="fnOnLoadMessage(false, 'like')">좋아요</a>
    <a class="btn "  v-if="!isClick" @click="fnOnLoadMessage(true, 'like')">좋아요</a>
    <a class="btn on_js" >찜하기</a>
</div>
